import { render, staticRenderFns } from "./6.vue?vue&type=template&id=e996fccc&scoped=true"
import script from "./6.vue?vue&type=script&lang=js"
export * from "./6.vue?vue&type=script&lang=js"
import style0 from "./6.vue?vue&type=style&index=0&id=e996fccc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996fccc",
  null
  
)

export default component.exports